module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_sola_black_vertical-e3111ba27e728b47d873b97ecb7d58e2.svg";